/**
 * @fileoverview People management route definitions.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { createRoutes } from '../utils/routeHelpers';

const EditPersonPage = lazy(() => import('../../features/people/pages/EditPersonPage'));
const PeopleHubPage = lazy(() => import('../../features/people/pages/PeopleHubPage'));
const PersonDetailPage = lazy(() => import('../../features/people/pages/PersonDetailPage'));

export const peopleRoutes: RouteObject[] = createRoutes([
  { path: 'people', Component: PeopleHubPage },
  { path: 'people/new', Component: EditPersonPage },
  { path: 'people/:personId', Component: PersonDetailPage },
  { path: 'people/:personId/edit', Component: EditPersonPage },
]);
